import { imagesUrls } from "../../constants";

type Props = {};

const IconDisplay = ({ withoutMarginTop }: { withoutMarginTop?: boolean }) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: withoutMarginTop ? undefined : "30px",
      }}
    >
      <img
        alt=""
        src={imagesUrls["arthereum"]}
        style={{
          height: "110px",
          width: "110px",
        }}
      />
    </div>
  );
};

export default IconDisplay;
